'use strict';
export default angular.module('focusOnEnter', [])
    .directive('focusOnEnter', function () {
    return {
        restrict: "A",
        link: function (scope, elem) {
            elem.bind('keydown keypress', function (e) {
                var code = e.keyCode || e.which;
                if (code === 13) {
                    e.preventDefault();
                    var pageElems = document.querySelectorAll('input, select, textarea, button[type="submit"]'), elem = e.srcElement, focusNext = false;
                    for (var i = 0; i < pageElems.length; i++) {
                        var pe = pageElems[i];
                        if (focusNext) {
                            if (pe.style.display !== 'none') {
                                pe.focus();
                                pe.click();
                                break;
                            }
                        }
                        else if (pe === e.srcElement || pe === e.target) { //target for firefox
                            focusNext = true;
                        }
                    }
                }
            });
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map